import { Link } from "react-router-dom";
import { NAV, SITE } from "@/content/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-plum-900 text-white">
    <div className="container-x relative grid gap-12 py-16 md:grid-cols-12 lg:py-20">
      <div className="md:col-span-5">
        <div className="inline-flex items-center gap-3 rounded-2xl bg-white px-4 py-3">
          <img src="/logo-mark.png" alt="" width="40" height="37" className="h-9 w-auto" />
          <img src="/logo-wordmark.png" alt="SwastSaathi" width="150" height="22" className="h-[22px] w-auto" />
        </div>
        <p className="mt-6 font-display text-2xl text-white">{SITE.tagline}</p>
        <p className="mt-3 max-w-sm text-sm leading-relaxed text-white/70">
          An idea-stage health-tech venture developing a community-based primary healthcare network for rural India,
          starting with a proposed pilot in Bihar.
        </p>
      </div>
      <div className="md:col-span-3">
        <h2 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-white/50">Explore</h2>
        <ul className="mt-5 space-y-3">
          {NAV.map((n) => (
            <li key={n.to}>
              <Link to={n.to} data-testid={`footer-link-${n.to === "/" ? "home" : n.to.slice(1)}`} className="text-sm text-white/80 transition-colors hover:text-white">
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-4">
        <h2 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-white/50">Get in touch</h2>
        <ul className="mt-5 space-y-3 text-sm text-white/80">
          <li><Link to="/partners#enquiry" data-testid="footer-partner-enquiry" className="hover:text-white">Partnership enquiry</Link></li>
          <li><Link to="/investors#enquiry" data-testid="footer-investor-enquiry" className="hover:text-white">Investment & incubation enquiry</Link></li>
          <li><Link to="/contact" data-testid="footer-general-enquiry" className="hover:text-white">General enquiry</Link></li>
          <li className="pt-2 text-white/60">Founder: {SITE.founder}</li>
          <li className="text-white/60">Website: <a href={SITE.url} className="text-white hover:underline" data-testid="footer-domain">{SITE.domain}</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-x flex flex-col gap-3 py-6 text-xs text-white/55 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} SwastSaathi · {SITE.domain}. SwastSaathi does not currently provide medical services. In an emergency, contact your nearest hospital or call 112.</p>
        <Link to="/privacy" data-testid="footer-privacy-link" className="text-white/75 hover:text-white">Privacy notice</Link>
      </div>
    </div>
  </footer>
);
